import { Button, Form, Input, Select } from "antd";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { jcTypeArray, getParamValue } from "../../utils";
import axios from "axios";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import { useParams } from "react-router";
import ImageUploader from "../FileManager/upload";
const { TextArea } = Input;
const { Option } = Select;

const AddCategory = ({ visibleData, onCloseMethod }: any) => {
  const [generatedImgUrl, setGeneratedImgUrl] = useState<string>();
  const [bannerImgUrl, setBannerImgUrl] = useState<string>();
  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);

  const [startUpload2, setStartUpload2] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);

  const [type, setType] = useState(
    getParamValue(window?.location.search, "type") || undefined
  );
  const [categoryData, setCategoryData] = useState(undefined);
  const route = useParams();

  const [categoryOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoryId, setCategoryId] = useState<any>();

  const getCategoryDetails = async (visibleData: any) => {
    if (visibleData) {
      await fetch(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/detail?categoryId=${visibleData}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            setCategoryData(res?.category);
            setType(res?.category?.type);
            setGeneratedImgUrl(res?.category?.image);
            setBannerImgUrl(res?.category?.bannerImage);
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const getCategoriesOptions = useCallback(async () => {
    if (type) {
      setCategoriesOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/parent-by-type?page=0&limit=50&type=${type}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setCategoriesOptions({
        loading: false,
        list: res?.data?.categories?.map(
          (category: { id: any; title: any }) => {
            return {
              value: category?.id,
              label: category?.title,
            };
          }
        ),
      });
    } else {
      responseNotification("Select a type before searching", "warning");
    }
  }, [type]);

  useEffect(() => {
    if (type) {
      getCategoriesOptions();
    }
  }, [type]);

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (startUpload === "Uploaded" && startUpload2 === "Uploaded") {
      form?.submit();
    }
  }, [startUpload, startUpload2]);

  const onSubmit = async (data: {
    title: any;
    slug: any;
    keyword: any;
    image: any;
    bannerImage: any;
    description: any;
    level: any;
    parent: any;
    position: any;
    type: any;
  }) => {
    if (generatedImgUrl) {
      setLoading(true);

      const readyData = data && {
        title: data.title,
        slug: data.slug,
        keyword: data.keyword,
        description: data.description,
        level: data.level,
        position: data.position,
        image: generatedImgUrl ? generatedImgUrl : data?.image,
        bannerImage: bannerImgUrl ? bannerImgUrl : data?.bannerImage,
        parent: (route as any)?.categoryId
          ? (route as any).categoryId
          : data.parent || null,
        type: (route as any)?.categoryId
          ? getParamValue(window?.location.search, "type")
          : data.type,
      };

      if (categoryData) {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            id: categoryData?.id,
            parent: data.parent,
            type: data.type,
            deleted: false,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Category Updated Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      } else {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/category`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Category Created Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      }
    } else {
      responseNotification(`Image required`, "error");
    }
    // [generatedImgUrl];
  };

  useEffect(() => {
    if (visibleData) {
      getCategoryDetails(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (categoryData) {
      form.resetFields();
    }
  }, [categoryData]);

  const resetData = () => {
    form?.resetFields();
    setType("");
    setGeneratedImgUrl(undefined);
    setBannerImgUrl(undefined);
    setStartUpload(undefined);
    setStartUpload2(undefined);
  };

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          autoComplete="off"
          initialValues={{
            ...categoryData,
          }}
        >
          <Form.Item
            hasFeedback
            label="Type"
            rules={[
              {
                required: true,
                message: "Type is required!",
              },
            ]}
            name="type"
          >
            <Select
              placeholder="Category Type"
              onChange={(val) => setType(val as string)}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item hasFeedback label="Category Parent" name="parent">
            <Select
              allowClear
              showSearch
              placeholder="Select Category Parent"
              optionFilterProp="children"
              onChange={(val) => setCategoryId(val)}
              onSearch={(e) => {
                getCategoriesOptions();
              }}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              disabled={!type}
            >
              {categoryOptions.list.length ? (
                <Option value={null}> -- Self Parent --</Option>
              ) : undefined}
              {categoryOptions.list.map(
                (category: {
                  value: { index: any };
                  label:
                    | boolean
                    | React.ReactChild
                    | React.ReactFragment
                    | React.ReactPortal;
                }) => (
                  <Option value={category?.value}>{category?.label}</Option>
                )
              )}
            </Select>
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Category Title"
            rules={[
              {
                required: true,
                message: "Category Title is Required!",
              },
            ]}
            name="title"
          >
            <Input id="title" type="text" placeholder="Enter Category Title" />
          </Form.Item>

          <Form.Item hasFeedback label="Category Position" name="position">
            <Input
              id="position"
              type="number"
              placeholder="Enter Category Position"
            />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Category Level"
            name="level"
            style={{ minWidth: "98%" }}
          >
            <Input
              id="level"
              type="number"
              placeholder="Enter Category Level"
            />
          </Form.Item>

          <Form.Item hasFeedback label="Keyword" name="keyword">
            <TextArea
              id="keyword"
              placeholder="Enter Category Keyword"
              rows={4}
            />
          </Form.Item>

          <Form.Item hasFeedback label="Description" name="description">
            <TextArea
              id="description"
              placeholder="Enter category Description"
              rows={4}
            />
          </Form.Item>

          <h4 className="title" style={{ maxWidth: "99%" }}>
            Image:
          </h4>
          <div className="">
            <h6>Category Image</h6>
            <ImageUploader
              imgUrl={generatedImgUrl || ""}
              startUpload={startUpload}
              setStartUpload={(val: any) => setStartUpload(val)}
              setGeneratedImgUrl={(url: any) => setGeneratedImgUrl(url)}
            />
          </div>
          <div className="">
            <h6>Banner Image</h6>
            <ImageUploader
              imgUrl={bannerImgUrl || ""}
              startUpload={startUpload2}
              setStartUpload={(val: any) => setStartUpload2(val)}
              setGeneratedImgUrl={(url: any) => setBannerImgUrl(url)}
            />
          </div>

          <div className="buttons-container">
            <Button
              disabled={
                loading ||
                startUpload === "Uploading" ||
                startUpload2 === "Uploading"
              }
              loading={
                loading ||
                startUpload === "Uploading" ||
                startUpload2 === "Uploading"
              }
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
              onClick={(e) => {
                e.preventDefault();
                setStartUpload("Uploading");
                setStartUpload2("Uploading");
              }}
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={resetData}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddCategory;
